export const ROUTES = {
    LOGIN: '/login',
    LOGIN_MICROSOFT: '/login/microsoft',
    FORGOT_PASSWORD: '/esqueci-minha-senha',
    RESET_PASSWORD: '/redefinir-senha',
    FIRST_ACCESS: '/primeiro-acesso',
    DASHBOARD: '/dashboard',
    PROFILE: '/perfil',
    DEVELOPMENTS: '/desenvolvimentos',
    DEVELOPMENT_NEW: '/desenvolvimentos/novo',
    DEVELOPMENT_DETAIL: '/desenvolvimentos/:id',
    NOTIFICATIONS: '/notificacoes',
    USERS: '/usuarios',
    USER_NEW: '/usuarios/novo',
    USER_EDIT: '/usuarios/:id',
    USER_ASSIGNMENTS: '/usuarios/:id/associacoes',
    CLIENTS: '/clientes',
    CLIENT_NEW: '/clientes/novo',
    CLIENT_EDIT: '/clientes/:id',
    PROJECTS: '/projetos',
    PROJECT_NEW: '/projetos/novo',
    PROJECT_EDIT: '/projetos/:id',
    REASONS: '/motivos',
    APPEARANCE: '/aparencia',
    REPORTS: '/relatorios'
} as const;

export const toDevelopmentDetail = (id: string) => `/desenvolvimentos/${encodeURIComponent(id)}`;
export const toUserEdit = (id: string) => `/usuarios/${encodeURIComponent(id)}`;
export const toUserAssignments = (id: string) => `/usuarios/${encodeURIComponent(id)}/associacoes`;
export const toClientEdit = (id: string) => `/clientes/${encodeURIComponent(id)}`;
export const toProjectEdit = (id: string) => `/projetos/${encodeURIComponent(id)}`;
